import React from 'react'
import { Link } from 'react-router-dom';
import { Button, Card } from 'reactstrap';
import FalconCardHeader from '../common/FalconCardHeader';
import PageHeader from '../common/PageHeader'

const Root = () => {

    return  <>
                <PageHeader
                    title='Gestion del sistema Homelan'
                    titleTag="h2"
                    description="Gestión general del sistema."
                    className="mb-3"
                    col={{ lg: 9 }}
                />
                <Card className='mb-3'>
                    <Button className='p-0' color='falcon-default' tag={Link} to="/root/condominiums">
                        <FalconCardHeader title='Condominios' subtitle='Presiona para gestionar' />
                    </Button>
                </Card>
                <Card className='mb-3'>
                    <Button className='p-0' color='falcon-default' tag={Link} to="/root/indicators">
                        <FalconCardHeader title='Indicadores' subtitle='Presiona para consultar' />
                    </Button>
                </Card>
                <Card className='mb-3'>
                    <Button className='p-0' color='falcon-default' tag={Link} to="/root/support">
                        <FalconCardHeader title='Soporte' subtitle='Presiona para gestionar' />
                    </Button>
                </Card>
                <Card className='mb-3'>
                    <Button className='p-0' color='falcon-default' tag={Link} to="/root/config">
                        <FalconCardHeader title='Configuración' subtitle='Presiona para gestionar' />
                    </Button>
                </Card>
                <Card className='mb-3'>
                    <Button className='p-0' color='falcon-default' tag={Link} to="/root/lead">
                        <FalconCardHeader title='Leads' subtitle='Presiona para gestionar' />
                    </Button>
                </Card>
            </>
}

export default Root;